{
  "Sign In - EventLive": "Zaloguj się - EventLive",
  "Forgot Password - EventLive": "Odzyskiwanie hasła - EventLive",
  "Password Restore Link Sent - EventLive": "Wysłano link do odzyskania hasła - EventLive",
  "Event": "Wydarzenie",
  "Event Details": "Szczegóły wydarzenia",
  "Details": "Szczegóły",
  "How to Go Live": "Jak rozpocząć transmisję",
  "Multi-Camera": "Wiele kamer",
  "Add a room": "Dodaj salę",
  "Guest List": "Lista gości",
  "Import Guests": "Importuj gości",
  "Add a Guest": "Dodaj gościa",
  "Event Analytics": "Statystyki wydarzenia",
  "Purchase Successful": "Zakup zakończony powodzeniem",
  "Test EventLive": "Przetestuj EventLive",
  "Schedule Event": "Zaplanuj wydarzenie",
  "Download everything": "Pobierz wszystko",
  "Update Email": "Zmień adres e-mail",
  "Help Us Grow": "Pomóż nam się rozwijać",
  "Set a New Password - EventLive": "Ustaw nowe hasło - EventLive",
  "Are you sure?": "Czy na pewno?",
  "Could not load data. Please check your internet connection. Ensure the timezone, date and time on your device are correct.": "Nie udało się wczytać danych. Sprawdź połączenie z internetem. Upewnij się, że strefa czasowa, data i godzina na urządzeniu są prawidłowe.",
  "Couldn't save your profile": "Nie udało się zapisać profilu",
  "Link required": "Link jest wymagany",
  "Overview": "Przegląd",
  "{days}-Day Event: {start} – {end}": "Wydarzenie {days}-dniowe: {start} – {end}",
  "Close event": "Zamknij wydarzenie",
  "This sign-in link has expired": "Ten link do logowania wygasł",
  "Couldn't sign you in from this link": "Nie udało się zalogować za pomocą tego linku",
  "Please sign in to continue.": "Zaloguj się, aby kontynuować.",
  "Couldn't save your changes": "Nie udało się zapisać zmian",
  "TEST": "TEST",
  "Download EventLive for Mac": "Pobierz EventLive na Maca",
  "Download for": "Pobierz na",
  "People": "Osoby",
  "Team invite - EventLive": "Zaproszenie do zespołu - EventLive"
}
